import React from 'react'

function SourcingService()
{
    return (
        <div className="sub_page_wrapper page_content">
            <h3>Strategic Sourcing and Supply Chain</h3>

            <p>Smart Khalanga Solutions (Pty) Ltd has extensive experience in the sourcing
and supply of in a very broad range of IT related assets and have no limit to
what the company can do.</p>

            <div>
                <label>We specialise in:</label>
                <ul>
                    <li>Desktop Computers – hardware and software</li>
                    <li>Laptops</li>
                    <li>Printers</li>
                    <li>Servers and switches</li>
                    <li>Routers</li>
                    <li>WIFI modems</li>
                    <li>Networking cables and related accessories</li>
                    <li>Software</li>
                </ul>
            </div>

            <p>
            Our knowledge and skills in strategic sources and working with an extensive network of
providers gives us leverage to source IT assets at the best price for our valued customers.
All procured assets will be delivered to the clients’ premises, and we have the expertise to
install, support and maintain as per the clients need.
            </p>
        </div>
    )
}

export default SourcingService;